import { setDistinctId } from './set-distinct-id'
import { generateDistinctId } from '../generate-distinct-id'

export function resetDistinctId() {
  setDistinctId(generateDistinctId())
}
